import * as $ from 'jquery';

export default class LaborCalculator {
	// S = splice, T = traditional, C = Clearfield
	private wrapper: HTMLElement = document.querySelector('.laborCalculator');
	private fields: NodeListOf<HTMLInputElement>;
	private fieldsS: Array<HTMLInputElement>;
	private fieldsT: Array<HTMLInputElement>;
	private fieldsC: Array<HTMLInputElement>;
	private resultsS: NodeListOf<HTMLElement>;
	private resultsT: HTMLElement;
	private resultsC: HTMLElement;
	private resultsDistT: HTMLElement;
	private resultsDistC: HTMLElement;
	private resultsCostT: HTMLElement;
	private resultsCostC: HTMLElement;
	private resultsHeadT: HTMLElement;
	private resultsHeadC: HTMLElement;
	private fieldCostDrop: HTMLInputElement;
	private fieldCostDist: HTMLInputElement;
	
	private final: HTMLElement;
	private finalHead: HTMLElement;
	private finalHide: HTMLElement;
	private finalCost: HTMLElement;
	
	setup() {
		this.fields = this.wrapper.querySelectorAll('input[disabled]');
		this.fieldsS = [];
		this.fieldsT = [];
		this.fieldsC = [];
		this.resultsS = this.wrapper.querySelectorAll('.results__count');
		this.resultsT = this.wrapper.querySelector('.section--trad');
		this.resultsC = this.wrapper.querySelector('.section--clear');
		this.resultsDistT = this.resultsT.querySelector('.results__length');
		this.resultsDistC = this.resultsC.querySelector('.results__length');
		this.resultsCostT = this.resultsT.querySelector('.results__cost');
		this.resultsCostC = this.resultsC.querySelector('.results__cost');
		this.resultsHeadT = this.resultsT.querySelector('.heading');
		this.resultsHeadC = this.resultsC.querySelector('.heading');
		this.fieldCostDrop = this.wrapper.querySelector('input#cost-per-splice');
		this.fieldCostDist = this.wrapper.querySelector('input#cost-per-distance');
	
		this.final = this.wrapper.querySelector('.section--final');
		this.finalHead = this.final.querySelector('.heading');
		this.finalHide = this.final.querySelector('.results');
		this.finalCost = this.final.querySelector('.results__cost');
	}

	formatOutputCurrency(num: number, place: number = 2){
		return '$' + num.toFixed(place).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,').replace('.00', '');
	}
	formatInputCurrency(str: string){
		return '$' + str;
	}
	sanitizeField(field: HTMLInputElement) {
		// console.assert(field.value !== '', 'field empty');
		if (field.value !== '') {
			field.value = field.value.replace(/[^\d.]/g, '');

			if (field.getAttribute('data-type') == 'currency'){
				field.value = this.formatInputCurrency(field.value);
			}
		}
	}
	updateResults() {
		// sum splices
		let sumSplices: number = 0;
		this.fieldsS.forEach(function (element) {
			sumSplices = sumSplices + (parseFloat(element.value) || 0);
		});
		for (var i = 0, l = this.resultsS.length; i < l; i++) {
			this.resultsS[i].innerHTML = sumSplices.toString();
		}

		// sum lengths
		let sumLengthT: number = 0;
		this.fieldsT.forEach(function (element) {
			sumLengthT = sumLengthT + (parseFloat(element.value) || 0);
		});
		this.resultsDistT.innerHTML = sumLengthT.toString() || 'N/A';

		let sumLengthC: number = 0;
		this.fieldsC.forEach(function (element) {
			sumLengthC = sumLengthC + (parseFloat(element.value) || 0);
		});
		this.resultsDistC.innerHTML = sumLengthC.toString() || 'N/A';

		// calculate costs
		// let fcDrop = parseFloat(this.fieldCostDrop.value);
		let fcDrop = parseFloat(this.fieldCostDrop.value.replace('$', ''));
		let fcDist = parseFloat(this.fieldCostDist.value.replace('$', ''));
		// let fcDist = parseFloat(this.fieldCostDist.value);

		let costT = (fcDrop * sumSplices) + (fcDist * sumLengthT);
		let costC = (fcDrop * sumSplices) + (fcDist * sumLengthC);
		this.resultsCostT.innerHTML = costT.toString() == 'NaN' ? 'N/A' : this.formatOutputCurrency(costT);
		this.resultsCostC.innerHTML = costC.toString() == 'NaN' ? 'N/A' : this.formatOutputCurrency(costC);

		// console.log(fcDrop , sumSplices , fcDist , sumLengthT , sumLengthC);
		// section--final
		if (fcDrop && sumSplices && fcDist && sumLengthT && sumLengthC){
			this.finalHide.removeAttribute('hidden');
			this.finalHead.innerHTML = (costT > costC ? this.resultsHeadC : this.resultsHeadT).innerHTML.replace('<br>', '');
			this.finalCost.innerHTML = this.formatOutputCurrency( (costT > costC ? costT - costC : costC - costT) );
		} else {
			this.finalHead.innerHTML = this.finalHead.getAttribute('data-default');
			this.finalHide.setAttribute('hidden', 'hidden');
		}
	}
	setupFields() {
		for (var i = 0, l = this.fields.length; i < l; i++) {
			const field = this.fields[i];
			const ID = field.id;

			field.addEventListener('keyup', (event) => {
				this.sanitizeField(field);
				this.updateResults();
			});
			field.removeAttribute('disabled');

			if (ID.indexOf('drop') > -1) {
				this.fieldsS.push(field);
				continue;
			}
			if (ID.indexOf('dist') > -1 && ID.indexOf('trad') > -1) {
				this.fieldsT.push(field);
				continue;
			}
			if (ID.indexOf('dist') > -1 && ID.indexOf('clear') > -1) {
				this.fieldsC.push(field);
				continue;
			}
			if (ID == 'cost-per-distance' || ID == 'cost-per-splice') {
				if (field.value !== ''){
					this.sanitizeField(field);
					field.parentElement.classList.add('fieldArea--isFilled');
				}
			}
		}
	}



	constructor() {
		console.log('laborCalculator');
		if (!this.wrapper) {
			return;
		}
		this.setup();
		this.setupFields();
		this.updateResults();

		console.group();
		console.log(this.fieldsC);
		console.assert(this.fieldsC.length === 12, 'fieldsC.length 12 != ' + this.fieldsC.length);
		console.assert(this.fieldsS.length === 12, 'fieldsS.length 12 != ' + this.fieldsS.length);
		console.assert(this.fieldsT.length === 12, 'fieldsT.length 12 != ' + this.fieldsT.length);
		console.groupEnd();
	}
}
